import { checkout } from "./checkout";
import { login } from "./login";
import type {
	NavigateHandler,
	NavigateHandlerMap,
	NavigateTarget,
} from "./types";

// `NavigateHandlerMap` stays internal: it only exists to type the catalog.
export type {
	NavigateHandler,
	NavigateHandlerContext,
	NavigateTarget,
} from "./types";

/**
 * The global, fixed catalog: one entry per file, so this list stays a table of
 * contents. The `NavigateHandlerMap` annotation is what makes a missing entry
 * a compile error.
 */
export const NAVIGATE_HANDLERS: NavigateHandlerMap = {
	checkout,
	login,
};

/**
 * Look up a route coming from an app. The own-key guard matters: routes
 * arrive as arbitrary strings, and a plain index would happily resolve
 * inherited keys such as `"toString"`.
 */
export function getNavigateHandler(route: string): NavigateHandler | undefined {
	if (!Object.prototype.hasOwnProperty.call(NAVIGATE_HANDLERS, route)) {
		return undefined;
	}
	return NAVIGATE_HANDLERS[route as NavigateTarget];
}
